import { TFunction } from 'i18next';

export enum CommandTypeEnum {
	Unlock = 'Unlock',
	Lock = 'Lock',
	Reboot = 'Reboot',
	OfficeMode = 'OfficeMode',
	BatteryLock = 'BatteryLock',
	BatteryUnlock = 'BatteryUnlock',
	EnableOfficeMode = 'EnableOfficeMode',
	DisableOfficeMode = 'DisableOfficeMode',
	HardwareReset = 'HardwareReset',
	Synchronise = 'Synchronise',
	TriggerGps = 'TriggerGPS',
	ControllerRelay1Pulse = 'ControllerRelay1Pulse',
	ControllerRelay1Follow = 'ControllerRelay1Follow',
	ControllerRelay1Toggle = 'ControllerRelay1Toggle',
	ControllerRelay1On = 'ControllerRelay1On',
	ControllerRelay1Off = 'ControllerRelay1Off',
	ControllerRelay2Pulse = 'ControllerRelay2Pulse',
	ControllerRelay2Follow = 'ControllerRelay2Follow',
	ControllerRelay2Toggle = 'ControllerRelay2Toggle',
	ControllerRelay2On = 'ControllerRelay2On',
	ControllerRelay2Off = 'ControllerRelay2Off',
	SetConnectivityProfile = 'SetConnectivityProfile',
}

export const isRelay1Action = (commandType: CommandTypeEnum): boolean => {
	return [
		CommandTypeEnum.ControllerRelay1Pulse,
		CommandTypeEnum.ControllerRelay1Follow,
		CommandTypeEnum.ControllerRelay1Toggle,
		CommandTypeEnum.ControllerRelay1On,
		CommandTypeEnum.ControllerRelay1Off,
	].includes(commandType);
};

export const isRelay2Action = (commandType: CommandTypeEnum): boolean => {
	return [
		CommandTypeEnum.ControllerRelay2Pulse,
		CommandTypeEnum.ControllerRelay2Follow,
		CommandTypeEnum.ControllerRelay2Toggle,
		CommandTypeEnum.ControllerRelay2On,
		CommandTypeEnum.ControllerRelay2Off,
	].includes(commandType);
};

export const getCommandTypeApiValue = (commandType: CommandTypeEnum) => {
	switch (commandType) {
		case CommandTypeEnum.DisableOfficeMode:
			return 'DisableOfficeMode';
		case CommandTypeEnum.EnableOfficeMode:
			return 'OfficeMode';
		default:
			return commandType;
	}
};

export const getCommandTypeDisplayName = (commandType: CommandTypeEnum, t: TFunction): string => {
	switch (commandType) {
		case CommandTypeEnum.Unlock:
			return t('unlock', { ns: 'actions' });
		case CommandTypeEnum.Lock:
			return t('lock', { ns: 'actions' });
		case CommandTypeEnum.Reboot:
			return t('reset', { ns: 'actions' });
		case CommandTypeEnum.OfficeMode:
			return t('enableOfficeMode', { ns: 'actions' });
		case CommandTypeEnum.BatteryLock:
			return t('batteryLock', { ns: 'actions' });
		case CommandTypeEnum.BatteryUnlock:
			return t('batteryUnlock', { ns: 'actions' });
		case CommandTypeEnum.EnableOfficeMode:
			return t('enableOfficeMode', { ns: 'actions' });
		case CommandTypeEnum.DisableOfficeMode:
			return t('disableOfficeMode', { ns: 'actions' });
		case CommandTypeEnum.HardwareReset:
			return t('hardwareReset', { ns: 'actions' });
		case CommandTypeEnum.Synchronise:
			return t('synchronise', { ns: 'actions' });
		case CommandTypeEnum.TriggerGps:
			return t('triggerGps', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay1Pulse:
			return t('relayPulse', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay1Follow:
			return t('relayFollow', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay1Toggle:
			return t('relayToggle', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay1On:
			return t('relayOn', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay1Off:
			return t('relayOff', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay2Pulse:
			return t('relayPulse', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay2Follow:
			return t('relayFollow', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay2Toggle:
			return t('relayToggle', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay2On:
			return t('relayOn', { ns: 'actions' });
		case CommandTypeEnum.ControllerRelay2Off:
			return t('relayOff', { ns: 'actions' });
		case CommandTypeEnum.SetConnectivityProfile:
			return t('setConnectivityProfile', { ns: 'actions' });
	}
};

export default CommandTypeEnum;
